var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "mb-2 ml-4" }, [_vm._v("Filtrer par...")]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "ml-4": "" } },
        [
          _c(
            "v-flex",
            { attrs: { shrink: "", "mr-3": "" } },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "", row: "", "fill-height": "" } },
                [
                  _c("v-switch", {
                    staticClass: "py-0 my-0",
                    attrs: {
                      color: "primary",
                      "hide-details": "",
                      label: _vm.$t(_vm.lblSetting.amCharPbDisabled)
                    },
                    model: {
                      value: _vm.attachmentTypeDisabled,
                      callback: function($$v) {
                        _vm.attachmentTypeDisabled = $$v
                      },
                      expression: "attachmentTypeDisabled"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.attachmentTypes
        ? _c(
            "v-layout",
            { attrs: { "mt-2": "", column: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                _vm._l(_vm.attachmentTypes, function(item) {
                  return _c(
                    "v-flex",
                    { key: item.id, staticClass: "pa-4", attrs: { xs2: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          staticStyle: {
                            "text-decoration": "none",
                            color: "black"
                          },
                          attrs: { to: "attachment-type/" + item.id }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "", "align-center": "" } },
                            [
                              _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    size: "60",
                                    color: item.enabled ? "primary" : "#848484"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "pa-1",
                                    attrs: {
                                      src: item.enabled
                                        ? item.icon
                                        : item.icon_grey
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mt-2",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_c("b", [_vm._v(_vm._s(item.name))])]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d73d1de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d73d1de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/attachment-type/template.html
// module id = null
// module chunks = 